import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "../../../styles/removeVantcell.css?vue&type=style&index=0&lang=css"
import "./index.vue?vue&type=style&index=1&id=461a3fe6&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-461a3fe6"]])

export default __exports__